
export class OAUTH2Response {
  token_type: string;
  expires_in: number;
  expires_on: number;
  not_before: number;
  resource: string;
  access_token: string;
  id_token: string;
  refresh_token: string;
  scope: string;
}
